import * as chat from './chat.api'
import * as message from './message.api'
import * as widget from './widget.api'
import * as ws from './ws.api'

export const messenger = {
    chat,
    message,
    widget,
    ws,
}

export * from './types'